"use client"

import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { Calendar } from "lucide-react"
import type { PortfolioData } from "@/types/portfolio"

interface StickyCtaProps {
  data: PortfolioData
}

export function StickyCta({ data }: StickyCtaProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600)
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-4 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] lg:bg-white/95 lg:backdrop-blur-md">
      <div className="container mx-auto flex items-center justify-between gap-4">        <p className="hidden sm:block text-sm font-medium text-foreground">
          Demo personalizada · Sin compromiso · Respuesta en 24h
        </p>
        <Button
          asChild
          size="lg"
          className="w-full sm:w-auto text-white shrink-0"
          style={{ backgroundColor: "#F97316" }}
        >
          <a href={data.profile.ctaUrl} target="_blank" rel="noopener noreferrer">
            <Calendar className="mr-2 h-4 w-4" />
            {data.profile.ctaText}
          </a>
        </Button>
      </div>
    </div>
  )
}
